<template>
  <div class="container">
    <div class="operation-condition">
      <div>
        <label style="margin-right: 8px; font-size: 14px" for>年份:</label>
        <el-select
          v-model="selectYearValue"
          placeholder="全部"
          style="width: 120px"
          @change="handleSocietyActivityList"
        >
          <el-option
            v-for="(item, index) in yearList"
            :key="index"
            :label="item"
            :value="item"
          />
        </el-select>
        <label style="margin-left: 12px; font-size: 14px" for>期数:</label>
        <el-select
          v-model="selectQiValue"
          placeholder="全部"
          style="margin-left: 10px; width: 120px"
          @change="handleSocietyActivityList"
        >
          <el-option
            v-for="(item, index) in numberList"
            :key="index"
            :label="item"
            :value="item"
          />
        </el-select>
      </div>
      <div>
        <el-input
          placeholder="请输入期刊文章"
          v-model.trim="searchInfo"
          style="margin-left: 20px; min-width: 300px"
        >
          <el-button type="primary" slot="append" @click="searchHandler"
            >搜索</el-button
          >
        </el-input>
      </div>
      <div style="float: right">
        <el-button
          v-on:click="addActivity"
          type="primary"
          style="width: 80px"
          v-if="isManage"
          >新建</el-button
        >
        <el-button
          type="danger"
          style="width: 80px"
          v-if="isManage"
          v-bind:disabled="delDisable"
          v-on:click="delClick"
          >删除</el-button
        >
      </div>
    </div>
    <div class="table_div">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#eef1f6' }"
      >
        <el-table-column align="center" type="selection" width="55" />
        <el-table-column type="index" label="序号" align="center" width="60">
        </el-table-column>
        <el-table-column
          prop="id"
          label="期刊文章ID"
          align="center"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="journalYear"
          label="年份"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.clazz == 4">{{ "暂无" }}</span>
            <span v-else>{{ scope.row.journalYear + "年" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="journalNumber"
          label="期数"
          align="center"
          width="100"
        >

          <template slot-scope="scope">
            <span v-if="scope.row.clazz == 1">{{
              "第" + scope.row.journalNumber + "期"
            }}</span>
            <span v-if="scope.row.clazz == 4">{{
              scope.row.editNum == null
                ? "暂无"
                : "第" + scope.row.editNum + "辑"
            }}</span>
          </template>

        </el-table-column>
        <el-table-column prop="title" label="文章名称" align="center">
        </el-table-column>

        <el-table-column prop="author" label="作者" align="center" width="140">
        </el-table-column>

        <el-table-column prop="status" align="center" width="120" label="状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == '0'" type="success"
              >发布中</el-tag
            >
            <el-tag v-if="scope.row.status == '1'" type="info">未发布</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="sort"
          label="置顶顺序"
          align="center"
          width="100"
        >
        </el-table-column>

        <el-table-column
          prop="operate"
          align="center"
          v-if="isManage"
          width="260"
          :key="Math.random()"
          label="操作"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              content="预览"
              placement="bottom"
            >
              <i class="el-icon-view" @click="handleClickView(scope.row)"></i>
            </el-tooltip>
            <!-- <el-popover
              placement="bottom"
              title=""
              width="260"
              trigger="click"
              @show="handleClickView(scope.row)"
              >
              <div>
                <embed
                  :src="filePath"
                  type="application/pdf"
                  width="100%"
                  height="height: 195px;"
                  />
              </div>
              <i class="el-icon-view" slot="reference" ></i>
            </el-popover> -->
            <i class="el-icon-edit" @click="handleEditClick(scope.row)"></i>
            <i class="el-icon-delete" @click="handleDeleteClick(scope.row)"></i>
            <i
              class="iconfont el-icon-mydownloadshuyi_zhiding"
              @click="handleToTop(scope.row)"
            ></i>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.page_num"
          :page-size="pagenation.page_size"
          background
          layout="total, prev, pager, next"
          :total="pagenation.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import dictionaryResearchApi from '@/api/dictionaryResearch'
import { mapRequestActions } from '@/utils'
import { MessageBox } from 'element-ui'
import { checkRole } from '@/utils/auth'
export default {
  data () {
    return {
      loading: false,
      thumbPath: '',
      filePath: '',
      isManage: false, // 是否是管理用户
      selectYearValue: '全部',
      selectQiValue: '全部',
      optionStatus: '',
      searchInfo: '',
      options: [],
      yearList: [],
      numberList: [],
      selectArr: [],
      delDisable: true,
      tableData: [],
      pagenation: {
        page_num: 1,
        page_size: 10,
        total: 0
      }
    }
  },
  created () {
    this.handleSocietyActivityList()
    this.handleSelectMagazine()
    this.isManage = checkRole(['manage'])
  },
  methods: {
    ...mapRequestActions(dictionaryResearchApi),

    /**
     * 获取期刊文章列表
     */
    handleSocietyActivityList () {
      this.getMagazineDicResearchAction({
        title: this.searchInfo,
        journalYear:
          this.selectYearValue === '全部' ? '' : this.selectYearValue,
        journalNumber: this.selectQiValue === '全部' ? '' : this.selectQiValue,
        pageNum: this.pagenation.page_num,
        pageSize: this.pagenation.page_size
      }).then((res) => {
        if (res.status) {
          this.pagenation = Object.assign({}, this.pagenation, {
            currentPage: 1,
            total: res.result.total
          })
          this.tableData = res.result.rows || []
        }
      })
    },

    /**
     * 分页
     */
    handleCurrentChange (newPage) {
      this.pagenation = Object.assign({}, this.pagenation, { newPage })
      this.handleSocietyActivityList()
    },

    searchHandler () {
      this.handleSocietyActivityList()
    },
    /**
     * 预览
     */
    handleClickView (item) {
      this.$router.push({
        path: '/dictionary-magazine-edit',
        query: { id: item.id, isView: true }
      })
    },
    /**
     * 置顶一条信息
     */
    async handleToTop (item) {
      const resultData = await this.setToTopAction({
        module: item.module,
        id: item.id
      })
      if (resultData.status) {
        this.$message.success('置顶成功')
        this.handleSocietyActivityList()
      } else {
        this.$message.error('操作失败')
      }
    },

    // selected items change
    handleSelectionChange (arr) {
      this.selectArr = arr
      if (arr.length !== 0) {
        this.delDisable = false
      } else {
        this.delDisable = true
      }
    },
    /**
     * 新增
     */
    addActivity () {
      this.$router.push('/dictionary-magazine-add')
    },
    /**
     * 编辑
     */
    handleEditClick (item) {
      this.$router.push({
        path: '/dictionary-magazine-edit',
        query: { id: item.id }
      })
    },
    /**
     * 获取下拉筛选 年/期 状态
     */
    async handleSelectMagazine () {
      const resultData = await this.getSelectMagazineAction()
      if (resultData.status) {
        this.yearList = resultData.result.yearList || []
        this.yearList.unshift('全部')
        this.numberList = resultData.result.numberList || []
        this.numberList.unshift('全部')
      }
    },

    /**
     * 删除 全选操作
     */
    delClick () {
      const _this = this
      MessageBox.confirm('此操作将永久删除该期刊文章, 是否继续?', '提示').then(
        () => {
          const longIds = _this.selectArr.map((item) => item.id)
          this.deleteMagazineDicResearchAction({ longIds }).then((res) => {
            if (res.status) {
              _this.$message({
                type: 'success',
                message: '删除成功'
              })
              _this.handleSocietyActivityList()
            } else {
              _this.$message.error(res.errorMsg || '删除失败')
            }
          })
        }
      )
    },
    /**
     * 删除 单选操作
     */
    handleDeleteClick (item) {
      const _this = this
      MessageBox.confirm('此操作将永久删除该期刊文章, 是否继续?', '提示').then(
        () => {
          const longIds = [item.id]
          this.deleteMagazineDicResearchAction({ longIds }).then((res) => {
            if (res.status) {
              _this.$message.success('删除成功')
              _this.handleSocietyActivityList()
            } else {
              _this.$message.error(res.errorMsg || '删除失败')
            }
          })
        }
      )
    }
  }
}
</script>

<style lang='less' scoped>
@import "../index.less";
</style>
